import styled from 'styled-components';

/** Região scrollável com foco de teclado (scrollable-region-focusable). */
export const Container = styled.div`
  height: 80vh;
  overflow-y: auto;
  outline: none;

  &:focus-visible {
    box-shadow: inset 0 0 0 2px #1677ff;
  }

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const ItemGlossarioArea = styled.div`
  padding-top: 5em;

  @media (max-width: 1244px) {
    padding-top: 6.6em;
  }
`;
